/**
 * ３桁ごとにカンマを付けた文字列を返す
 * @param {number|string} number - 数値または数値の文字列
 */
export const addComma = (number: number | string): string => {
  return String(number).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
};
